import React from "react";

import BusinessSizeBreakdownInfo from "./BusinessSizeBreakdownInfo.jsx";

/**
 * @typedef {import("../../../jsdoc/BusinessSizeCount.js").BusinessSizeCount} BusinessSizeCount
 */

/**
 * BusinessSizeBreakdown Component
 * @param {Object} props
 * @param {BusinessSizeCount[]} props.businessSizeCounts
 * @returns {React.JSX.Element}
 */
export default function BusinessSizeBreakdown({ businessSizeCounts }) {
  return (
    <div className="panel panel-primary table-responsive">
      <div className="panel-heading text-center">
        <strong>Business Size Set-aside Designation Breakdown</strong>
      </div>
      <div className="panel-body">
        <BusinessSizeBreakdownInfo businessSizeCounts={businessSizeCounts} />
      </div>
    </div>
  );
}
